import { API_ROOT, uniquenessCheck } from '../../supplementary_components/requests';



export const TEAM_ADD_FORM = {
    formAccessLevel: { key: 'TEAMS', level: 'MANAGE' },
    formTitle: "Add Team",
    name: 'addTeamForm',
    addLink: API_ROOT+'teams/add',
    successMessage:'Team was added',
    
    columns: [
        {
            label: "Team Name",
            autoComplete: "off",
            name: "teamName",
            mandatory: true,
            checks : [
                // 
                (value) => {
                    return value.includes("Solo Dispatch") ? '"Solo Dispatch" is reserved naming' : null;
                },
                async (value, column) => new Promise(resolve => {
                    if(column.defaultValue){
                        if(column.defaultValue() === value){
                            resolve(null);
                            return;
                        }
                    }
                    resolve(uniquenessCheck(API_ROOT+"teams/exists", "teamName", value, "Team with this name already exists"));
                }),
            ]
        },
        {
            label: "Team Members",
            type: "employeeSelectionForGeneratingTeams",
            name: "teamMembers",
            mandatory: true,
            // teamMembers : [],
            suggestionOptionsFormatter : (val) => {
                return {
                    value: `${val["firstName"]} ${val["lastName"]}`,
                    subPart: val["available"] === false ? ` (Assigned: ${val["teamName"]})` : ""
                }
            },
            processChanges: (column, data)=>{
                const membersListContainer = document.getElementById("teamMembersList");
                const ids = [];
                for(const inputTag of membersListContainer.querySelectorAll("input[name='member']")){
                    if(!inputTag.getAttribute('data-value')){
                        if(!inputTag.className.includes('subError')){
                            inputTag.classList += 'subError';
                            return null;
                        }
                    }else{
                        const parsdedData = JSON.parse(inputTag.getAttribute('data-value'));
                        ids.push(parsdedData.id);
                    }
                }
                data.id = parseInt(data.id); 
                data["teamMembersId"] = ids;
                return data;
                
            }
        },
    ]
}